// 扩展组件管理

const components = {
  root: [],
  navbar_left: [],
  navbar_center: [],
  navbar_right: [],
  windows: [],
  left_panel: [],
  right_panel: [],
  bottom_panel: [],
  element_info_panel: [],
  canvas_layers: [],
  selection_overlayer: [],
};

const contextMenu = {
  element: [],
  canvas: [],
  selection: [],
};

export const getContextMenu = () => {
  return contextMenu;
};

export const registerContextMenu = (type, { before, after, menu = [] }) => {
  let insertIndex = contextMenu[type].length;

  if (before) {
    if (typeof before === 'number') {
      insertIndex;
    } else if (typeof before === 'string') {
      insertIndex = contextMenu[type].findIndex((item) => item.name === before);
    }
  } else if (after) {
    if (typeof after === 'number') {
      insertIndex = after + 1;
    } else if (typeof after === 'string') {
      insertIndex = contextMenu[type].findIndex((item) => item.name === after) + 1;
    }
  }

  if (insertIndex < 0) {
    insertIndex = 0;
  }

  contextMenu[type].splice(insertIndex, 0, ...menu);
};

export const getComponents = () => {
  return components;
};

export const registerComponent = (type, { Component, config }) => {
  components[type].push({ Component, config });
};
